export const WorldToFieldMap: Map<number, string[]> = new Map<number, string[]>([
    [1, ['wheat','tomato','pumpkin','apple','sunflower','blueberry','lemon']],
    [2, ['strawberry','watermelon','orange','artichoke','cherry','carrot']],
    [3, ['grapes','pear','lavender','pepper']],
    [4, ['onion','cabbage','olive','eggplant']],
    [5, ['corn','pomegranate','zucchini','tangerine']],
    [6, ['tulip','calla','daffodil','peony']],
    [7, ['redcabbage','potato','raspberry','whiteasparagus']],
    [8, ['cucumber','pinenuts','lettuce','radish']],
    [9, ['date','barley','almond','honeymelon']],
    [10, ['leek','redcurrant','cauliflower','crowberry']],
    [11, ['rice','peach','greentea','lychee']],
    [12, ['garlic','peas','quince','bellpepper']],
    [13, ['mint','chamomile','rosemary','verbena']],
    [14, ['plumelia','macadamia','taro','konacoffee']],
    [15, ['manuka','lupine','kowhai','boysenberry']],
    [16, ['ginger','redplum','wasabi','persimmon']],
    [17, ['chili','papaya','agave','avocado']],
    [18, ['cotton','fig','sugarbeet','hazelnut']],
    [19, ['oat','plum','squash','chives']],
    [20, ['soybeans','banana','cassava','guarana']],
    [21, ['lentil','mango','okra','cashew']],
    [22, ['broccoli','apricot','beans','chestnut']],
    [23, ['coconut','dragonfruit','waterspinach','calabash']],
    [24, ['mustard','redcabbage2','greenapple','rhubarb']],
    [25, ['yellowazalea','redclover','ladyorchid','lily']],
    [26, ['sweetpotato','grapefruit','safflower','sugarcane']],
    [27, ['rapeseed','hop','nectarine','blackberry']],
    [28, ['berseem','pricklypears','loquat','papyrus']],
    [29, ['turnip','foxgloves','gooseberry','celery']],
]);

export const FieldToWorldMap: Map<string, number> = new Map<string, number>([
    ['wheat', 1],
    ['tomato', 1],
    ['pumpkin', 1],
    ['apple', 1],
    ['sunflower', 1],
    ['blueberry', 1],
    ['lemon', 1],
    ['strawberry', 2],
    ['watermelon', 2],
    ['orange', 2],
    ['artichoke', 2],
    ['cherry', 2],
    ['carrot', 2],
    ['grapes', 3],
    ['pear', 3],
    ['lavender', 3],
    ['pepper', 3],
    ['onion', 4],
    ['cabbage', 4],
    ['olive', 4],
    ['eggplant', 4],
    ['corn', 5],
    ['pomegranate', 5],
    ['zucchini', 5],
    ['tangerine', 5],
    ['tulip', 6],
    ['calla', 6],
    ['daffodil', 6],
    ['peony', 6],
    ['redcabbage', 7],
    ['potato', 7],
    ['raspberry', 7],
    ['whiteasparagus', 7],
    ['cucumber', 8],
    ['pinenuts', 8],
    ['lettuce', 8],
    ['radish', 8],
    ['date', 9],
    ['barley', 9],
    ['almond', 9],
    ['honeymelon', 9],
    ['leek', 10],
    ['redcurrant', 10],
    ['cauliflower', 10],
    ['crowberry', 10],
    ['rice', 11],
    ['peach', 11],
    ['greentea', 11],
    ['lychee', 11],
    ['garlic', 12],
    ['peas', 12],
    ['quince', 12],
    ['bellpepper', 12],
    ['mint', 13],
    ['chamomile', 13],
    ['rosemary', 13],
    ['verbena', 13],
    ['plumelia', 14],
    ['macadamia', 14],
    ['taro', 14],
    ['konacoffee', 14],
    ['manuka', 15],
    ['lupine', 15],
    ['kowhai', 15],
    ['boysenberry', 15],
    ['ginger', 16],
    ['redplum', 16],
    ['wasabi', 16],
    ['persimmon', 16],
    ['chili', 17],
    ['papaya', 17],
    ['agave', 17],
    ['avocado', 17],
    ['cotton', 18],
    ['fig', 18],
    ['sugarbeet', 18],
    ['hazelnut', 18],
    ['oat', 19],
    ['plum', 19],
    ['squash', 19],
    ['chives', 19],
    ['soybeans', 20],
    ['banana', 20],
    ['cassava', 20],
    ['guarana', 20],
    ['lentil', 21],
    ['mango', 21],
    ['okra', 21],
    ['cashew', 21],
    ['broccoli', 22],
    ['apricot', 22],
    ['beans', 22],
    ['chestnut', 22],
    ['coconut', 23],
    ['dragonfruit', 23],
    ['waterspinach', 23],
    ['calabash', 23],
    ['mustard', 24],
    ['redcabbage2', 24],
    ['greenapple', 24],
    ['rhubarb', 24],
    ['yellowazalea', 25],
    ['redclover', 25],
    ['ladyorchid', 25],
    ['lily', 25],
    ['sweetpotato', 26],
    ['grapefruit', 26],
    ['safflower', 26],
    ['sugarcane', 26],
    ['rapeseed', 27],
    ['hop', 27],
    ['nectarine', 27],
    ['blackberry', 27],
    ['berseem', 28],
    ['pricklypears', 28],
    ['loquat', 28],
    ['papyrus', 28],
    ['turnip', 29],
    ['foxgloves', 29],
    ['gooseberry', 29],
    ['celery', 29],
]);